import React from "react";
import InfoGridList from "./infoGridList";
import { Text, Input } from "@mantine/core";
import { useAuthUser } from "react-auth-kit";
import { useTabNavigate } from "../hooks/useTabNavigate";
import { getEntityTabLabel } from "../utils/tabNavigation";

export default function DebitNoteRelatedDocumentSection({
  form,
  name,
  readonly = false,
}) {
  const dn = form.values;
  const auth = useAuthUser();
  const tabNav = useTabNavigate();
  const userRole = auth().userRole;
  const orderLink =
    userRole.entityLinks.find((l) => l.entity === "order")?.link ?? "/gi/order";

  const renewalLink =
    userRole.entityLinks.find((l) => l.entity === "renewal")?.link ??
    "/gi/renewal";

  const quotationLink =
    userRole.entityLinks.find((l) => l.entity === "quotation")?.link ??
    "/gi/quotation";

  const openLinkedDocument = ({ pathname, id, label, entityType, entity }) => {
    if (!pathname || !id) return;
    const tabLabel =
      label || getEntityTabLabel(entity, id, entityType);
    if (tabNav.enabled) {
      tabNav.openDetail({ pathname, id, mode: "edit", label: tabLabel });
      return;
    }
    window.open(`${pathname}?id=${id}&mode=edit`, "_blank");
  };

  const renderDocumentLink = ({ pathname, entity, entityType }) => {
    if (!entity) return "-";

    const id = entity?._id ?? entity;
    const code = entity?.code ?? id;

    if (readonly) return <Text>{code}</Text>;

    return (
      <Text
        component="a"
        style={{ textDecoration: "none", cursor: "pointer" }}
        onClick={(e) => {
          e.preventDefault();
          openLinkedDocument({ pathname, id, label: code, entityType, entity });
        }}
      >
        {code}
      </Text>
    );
  };

  const fields = [
    {
      title: "Quotation",
      value: renderDocumentLink({
        pathname: quotationLink,
        entity: dn?.quotation,
        entityType: "quotation",
      }),
    },
    {
      title: "Renewal",
      value: renderDocumentLink({
        pathname: renewalLink,
        entity: dn?.renewal,
        entityType: "renewal",
      }),
    },
    {
      title: "Order",
      value: renderDocumentLink({
        pathname: orderLink,
        entity: dn?.order,
        entityType: "order",
      }),
    },
    // {
    //   title: "Order",
    //   value: dn?.order ? (
    //     !readonly ? (
    //       <a
    //         href={`${orderLink}?id=${dn.order?._id}&mode=${"edit"}`}
    //         target="_blank"
    //         style={{ textDecoration: "none" }}
    //       >
    //         {dn.order?.code}
    //       </a>
    //     ) : (
    //       <Text>{dn.order?.code}</Text>
    //     )
    //   ) : (
    //     "-"
    //   ),
    // },
    {
      title: "Insurer Settlement",
      value: dn?.giSettlement ? <Text>{dn.giSettlement?.code}</Text> : "-",
    },
  ];

  return (
    <>
      {/* <ReactJson
        src={form.values}
        collapsed={true}
        style={{ background: "white" }}
      /> */}
      {dn && <InfoGridList fields={fields} values={dn} cols={4} />}

      {dn && (
        <div style={{ margin: "16px 0" }}>
          <Input.Wrapper label="Force Renewable"></Input.Wrapper>
          <input
            type="checkbox"
            checked={!!dn.forceRenewal}
            disabled={readonly}
            onChange={(e) => {
              if (readonly) return;
              if (typeof form?.setFieldValue === "function") {
                form.setFieldValue("forceRenewal", e.target.checked);
              }
            }}
          />
        </div>
      )}
    </>
  );
}
